import { IGlobalStore } from 'src/types/store'
import {
  TStateCommunications,
  createStateSagaCommunications,
} from 'src/helpers/redux'
import { actions as sagaActions, PREFIX } from './actions'
import * as agentsTypes from 'src/services/agents/types'

export interface IMessage {
  id: string
  text: string
  isUser: boolean
  isError?: boolean
  createdAt: number
  isStreaming?: boolean
  metadata?: {
    responseTime?: number
    toolsCalled?: string[]
  }
}
export interface IWindow {
  x: number
  y: number
  height: number
  width: number
  open: boolean
  rightSideBar: boolean
  rightSideBarHover: boolean
}

type IGetMemoryThreadsPaginatedDataItem =
  agentsTypes.IGetMemoryThreadsPaginatedData['threads'][number]

export type IMemoryThreadMessage = agentsTypes.IMemoryThreadMessage
export type IMemoryThreadMessageAssistant =
  agentsTypes.IMemoryThreadMessageAssistant
interface IAssistandThreadsItem extends IGetMemoryThreadsPaginatedDataItem {
  messages?: {
    items: IMemoryThreadMessage[]
  }
}
interface IAssistandThreads extends agentsTypes.IGetMemoryThreadsPaginatedData {
  threads: IAssistandThreadsItem[]
}
export interface IStateData {
  threads: IAssistandThreads
  streamMessages: {
    [threadId: string]: agentsTypes.IMemoryThreadMessageAssistant | undefined
  }
  window: IWindow
}

export interface IState {
  data: IStateData
  communication: TStateCommunications<typeof sagaActions>
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const getStorageState = (key: string) => {
  try {
    return JSON.parse(localStorage.getItem(key) || '{}')
  } catch (error) {
    return {}
  }
}
export const getInitialData = (): IStateData => {
  const stateData = getStorageState(PREFIX)

  const state: IStateData = {
    messages: [],
    window: {
      rightSideBarHover: false,
      rightSideBar: false,
      x: window.innerWidth - 405,
      y: window.innerHeight - 555,
      open: false,
      width: 400,
      height: 550,
      ...stateData.window,
    },
    ...stateData,
    threads: {
      total: 0,
      page: 0,
      perPage: 0,
      hasMore: false,
      threads: [],
      ...stateData?.threads,
    },
    streamMessages: {},
  }

  return state
}

export const initialState: IState = {
  data: getInitialData(),
  communication: createStateSagaCommunications(sagaActions),
}

export type TGlobalStateWithService = IGlobalStore & {
  [PREFIX]: IState
}

export { PREFIX }
